import Editor from './Editor'
import Preview from './Preview'

const Pages = {
    Editor,
    Preview,
}

export default Pages
